<template>
  <div>
    <b-modal
      ref="modal-setting-rate"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="">
        <ValidationObserver ref="ref-validation-rate">
          <b-row>
            <!-- Client -->
            <b-col md="7">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="client_id"
              >
                <b-form-group
                  :label="$t('Client')"
                  label-for="client_id"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    id="client_id"
                    v-model="form.client_id"
                    :options="clients"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.id"
                    append-to-body
                    :clearable="false"
                    :calculate-position="positionDropdown"
                    label="name"
                    @input="changeClientId"
                    :disabled="rateId || disableSelect"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Service Type -->
            <b-col sm="5">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="service_type_id"
              >
                <feather-icon
                  v-if="form.client_id"
                  icon="PlusCircleIcon"
                  size="16"
                  v-b-tooltip.hover.v-primary
                  class="cursor-pointer text-primary"
                  style="float: right"
                  :title="$t('Add service type')"
                  @click="addServiceType"
                />
                <b-form-group
                  :label="$t('Service Type')"
                  label-for="service_type_id"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    id="service_type_id"
                    v-model="form.service_type_id"
                    :options="serviceTypes"
                    append-to-body
                    :clearable="false"
                    :calculate-position="positionDropdown"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.id"
                    label="name"
                    :disabled="form.client_id == null || disableSelect"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Travel Route -->
            <b-col sm="12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="travel_route_id"
              >
                <b-form-group
                  :label="$t('Travel Route')"
                  label-for="travel_route_id"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    id="travel_route_id"
                    v-model="form.travel_route_id"
                    :options="travelRoutes"
                    append-to-body
                    :clearable="false"
                    :calculate-position="positionDropdown"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.id"
                    label="travel_route"
                    @search="searchTravelRoutes"
                    :disabled="form.service_type_id == null || disableSelect"
                    @input="getSettingVehiclesFiltered()"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end" v-if="form.travel_route_id != null">
            <feather-icon
              v-if="rateId == null"
              icon="PlusCircleIcon"
              size="16"
              class="cursor-pointer text-primary"
              style="float: right"
              @click="addRow()"
            />
          </div>
          <template v-if="form.travel_route_id != null">
            <b-row v-for="(rate, index) in rateOptions" :key="index">
              <!-- Setting Vehicle -->
              <b-col lg="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="setting_vehicle_id"
                >
                  <b-form-group
                    :label="$t('Setting Vehicle')"
                    label-for="setting_vehicle_id"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      id="setting_vehicle_id"
                      v-model="rate.setting_vehicle_id"
                      :options="settingVehicles"
                      append-to-body
                      :clearable="false"
                      :calculate-position="positionDropdown"
                      :placeholder="`${$t('Select setting vehicle')}...`"
                      :reduce="(l) => l.id"
                      label="name"
                      @input="getMeasureTypesFiltered(index)"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Measure Type -->
              <b-col lg="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="measure_type"
                >
                  <b-form-group
                    :label="$t('Measure Type')"
                    label-for="measure_type"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      id="measure_type"
                      v-model="rate.measure_type"
                      :options="rate.measureTypes"
                      append-to-body
                      :clearable="false"
                      :calculate-position="positionDropdown"
                      :placeholder="`${$t('Select measure type')}...`"
                      :reduce="(l) => l.id"
                      label="name"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Amount -->
              <b-col :lg="rateId == null ? 3 : 4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="tolls"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Amount')"
                    label-for="amount"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <money
                      id="amount"
                    
                      v-model="rate.amount"
                      v-bind="{
                        decimal: '.',
                        thousands: ',',
                        prefix: prefix,
                        precision: 2,
                        masked: false,
                      }"
                      class="form-control input-form"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col v-if="rateId == null" lg="1" class="d-flex align-items-center">
                <div>
                  <feather-icon
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  size="18"
                  @click="deleteRow(index)"
                  />
                </div>
              </b-col>
            </b-row>
          </template>
        </ValidationObserver>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="rateId == null"
            @click="registerRate"
            variant="outline-success"
            >{{ $t("REGISTER") }}</b-button
          >
          <b-button
            v-if="rateId != null"
            @click="updateRate"
            variant="outline-warning"
            >{{ $t("UPDATE") }}</b-button
          >
        </div>
      </template>
    </b-modal>

    <ServiceTypeModal
      v-if="serviceTypeModal"
      :clientId="form.client_id"
      @hideModal="serviceTypeModal = false"
      @registered="refreshServiceTypes"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import VMoney from "v-money";
import ClientsService from "@/views/commons/clients/services/clients.service.js";
import TravelRoutesService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import VehiclesService from "@/views/settings/views/vehicles/services/vehicles.service.js";

import ServiceTypeModal from "@/views/settings/views/travel-routes/modals/ServiceTypeModal.vue";

export default {
  mixins: [modalMixin],
  components: {
    VMoney,
    ServiceTypeModal,
  },
  directives: {
    money: VMoney,
  },
  props: {
    rateId: {
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        client_id: null,
        service_type_id: null,
        travel_route_id: null,
      },
      travelRoutes: [],
      serviceTypes: [],
      settingVehicles: [],
      settingVehiclesCpy: [],
      measureTypesCpy: [],
      finishedLoading: false,
      vMoney: {
        decimal: ".",
        thousand: ".",
        prefix: "S/ ",
        suffix: "",
        min: 0.0,
        masked: false,
      },
      serviceTypeModal: false,
      rateOptions: [
        {
        "setting_vehicle_id": "",
        "measure_type": "",
        "amount": 0,
        "measureTypes":[]
        }
      ],
      disableSelect: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      if (this.rateId == null) return "NEW RATE";
      return "EDIT RATE";
    },
    prefix() {
      return "S/.";
    },
  },
  watch: {},
  mounted() {
    this.toggleModal("modal-setting-rate");
  },
  async created() {
    try {
      this.form.id = this.rateId;
      this.finishedLoading = false;
      this.measureTypesCpy = this.measureTypes;
      this.addPreloader();
      await Promise.all([
        this.getDataRateById(),
        this.getClients(),
        this.getSettingVehicles(),
      ]);
    } catch (error) {
      console.log(error);
      this.showToastError(error?.response?.data?.message);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  methods: {
    searchTravelRoutes: _.debounce(async function (search) {
      if (search.length < 3 || search == undefined) return;
      const { data } = await TravelRoutesService.getTravelRoutesForSelect({
        text: search,
      });
      this.travelRoutes = data;
    }),
    async getDataRateById() {
      if (this.rateId == null) return;
      try {
        const { data } = await TravelRoutesService.getDataRateById({
          rate_id: this.form.id,
        });
        this.form.client_id = data[0].client_id;
        await this.getServiceTypes();
        this.form.service_type_id = data[0].service_type_id;
        this.form.travel_route_id = data[0].travel_route_id;
        this.rateOptions[0].setting_vehicle_id = data[0].setting_vehicle_id;
        this.rateOptions[0].measure_type = data[0].measure_type_id;
        this.rateOptions[0].amount = data[0].amount;
        await this.getMeasureTypesFiltered(0);
        await this.changeClientId(data[0].client_id);
        await this.searchTravelRoutes(data[0].travel_route);
      } catch (error) {
        throw error;
      }
    },
    async registerRate() {
      const result = await this.$refs["ref-validation-rate"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          client_id: this.form.client_id,
          service_type_id: this.form.service_type_id,
          travel_route_id: this.form.travel_route_id,
          rate_options: this.rateOptions,
          user_id: this.currentUser.id,
        };
        const { data } = await TravelRoutesService.registerRate(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    async updateRate() {
      const result = await this.$refs["ref-validation-rate"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          rateId: this.rateId,
          cliente: this.form.client_id,
          serviceType: this.form.service_type_id,
          travelRoute: this.form.travel_route_id,
          settingVehicle: this.rateOptions[0].setting_vehicle_id,
          measureType: this.rateOptions[0].measure_type,
          amount: this.rateOptions[0].amount
        };
          const { data } = await TravelRoutesService.updateRate(params);
          if (data.success) {          
            this.showToastSuccess("Successfull process")
            this.$emit("hideModal")
            return;
          }else{
            this.showToastWarning("Error process");
          }          
          this.$emit("registered");
      } catch (error) {
        this.showToastError(error);
      } finally {
        this.removePreloader();
      }
    },
    async getClients() {
      try {
        const { data } = await ClientsService.getClientsForSelect();
        this.clients = data;
      } catch (error) {
        throw error;
      }
    },

    async getServiceTypes() {
      try {
        const { data } = await ClientsService.getServiceTypesForSelect({
          client_id: this.form.client_id,
        });
        this.serviceTypes = data;
      } catch (error) {
        throw error;
      }
    },

    async getSettingVehicles() {
      try {
        const { data } = await VehiclesService.getSettingVehiclesForSelect();
        this.settingVehicles = data;
        this.settingVehiclesCpy = data;
      } catch (error) {
        throw error;
      }
    },
    async getMeasureTypes(){
      try {
        const { data } = await VehiclesService.getMeasureTypes();
        this.measureTypes = data;      
      } catch (error) {
        throw error;
      }
    },
    async getSettingVehiclesFiltered(){
      if(this.form.client_id != null & this.form.service_type_id != null 
        & this.form.travel_route_id != null)
      {
        try {
          const params = {
            "client_id": this.form.client_id,
            "service_type_id": this.form.service_type_id
          }
          this.addPreloader();
          const { data } = await VehiclesService.getSettingVehiclesForSelect(params);
          this.settingVehicles = data;
          this.settingVehiclesCpy = data;
        } catch (error) {
          console.log(error)
        } finally {
          this.removePreloader();
        }
      }
    },    
    async getMeasureTypesFiltered(index){
      if(this.form.client_id != null & this.form.service_type_id != null 
        & this.form.travel_route_id != null & this.rateOptions[index].setting_vehicle_id != null)
      {
        this.disableSelect = true;
        try {
          const params = {
            "client_id": this.form.client_id,
            "service_type_id": this.form.service_type_id,
            "travel_route_id": this.form.travel_route_id,
            "setting_vehicle_id": this.rateOptions[index].setting_vehicle_id,
            "current_measure_id": this.rateOptions[index].measure_type
          }
          this.addPreloader();
          let data;
          let measureTypes;
          if(this.rateId){
            data = await VehiclesService.getMeasureTypesFilteredForEdit(params);
            measureTypes = data.data;
          }else{
            data = await VehiclesService.getMeasureTypesFiltered(params);
            let aux = this.rateOptions.filter(rate => rate.setting_vehicle_id == this.rateOptions[index].setting_vehicle_id)
            measureTypes = data.data.filter(item => {
              return !aux.some(rate => item.id == rate.measure_type)
            });
          }
          this.rateOptions[index].measureTypes = measureTypes;
        } catch (error) {
          console.log(error)
        } finally {
          this.removePreloader();
        }
      }
    },
    refreshMeasureTypes(id){
      this.measureTypes = this.measureTypes.filter(measure => {
        return !this.rateOptions.some(item => item.measure_type == measure.id & item.setting_vehicle_id == id)
      });
    },
    positionDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.style.zIndex = 9999;
      dropdownList.style.maxHeight = "20rem";
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
    },

    async changeClientId(clientId) {
      if (clientId == null) {
        this.form.service_type_id = null;
        this.serviceTypes = [];
        return;
      }
      try {
        this.addPreloader();
        await this.getServiceTypes();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    addServiceType() {
      this.serviceTypeModal = true;
    },

    async refreshServiceTypes() {
      this.serviceTypeModal = false;
      try {
        this.addPreloader();
        await this.getServiceTypes();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async addRow(){
      let length = this.rateOptions.length;
      if(!(this.rateOptions[length-1].measure_type == "" || 
        this.rateOptions[length-1].setting_vehicle_id == "")){
          const row = {
            "setting_vehicle_id": "",
            "measure_type": "",
            "amount": 0,
            "measureTypes": []
          };
          this.rateOptions.push(row);
      }else{
        await this.$refs["ref-validation-rate"].validate();
      }
    },
    deleteRow(index){
      this.rateOptions.splice(index, 1);
    },
    refreshSettingVehicles(){
      this.settingVehicles = this.settingVehiclesCpy.filter(setting => {
        return !this.rateOptions.some(rate =>  setting.id == rate.setting_vehicle_id)
      })
    }
  },
};
</script>

<style>
</style>